(function ($, Drupal, window, document) {

    'use strict';

Drupal.behaviors.move_element = {
    attach: function (context, settings) {

      var breakpointTablet = 640,
          breakpointDesktop = 960;

      var $menuSource = $('.s-menu--footer'),
          $menuDestination = $('.s-menu--main'),
          $menuOriginalDestination = $menuSource.prev(),
          // $advertSource = $('#block-advertblock-mgid'),
          // $advertDestination = $('.region-sidebar-first'),
          // $advertOriginalDestination = $advertSource.prev(),
          $copyrightSource = $('.region-footer-warning'),
          $copyrightDestination = $('.s-menu--footer'),
          $copyrightOriginalDestination = $copyrightSource.next();

      moveElement($menuSource, $menuDestination , $menuOriginalDestination, breakpointDesktop);
      moveElement($copyrightSource, $copyrightDestination , $copyrightOriginalDestination, breakpointTablet);

      $(window).resize(function () {
        moveElement($menuSource, $menuDestination , $menuOriginalDestination, breakpointDesktop, true);
        moveElement($copyrightSource, $copyrightDestination , $copyrightOriginalDestination, breakpointTablet, true);
      });

      
      function moveElement($source, $destination, $originalDestination, breakpoint, resize = false) {
        if ($(window).width() < breakpoint) {
          $source.insertAfter($destination);
        }
        else {
          if (resize) {
            $source.insertAfter($originalDestination);
          }
        }
      }

    }
};

})(jQuery, Drupal, this, this.document);